import Vue from 'vue';
import Router from 'vue-router';
import store from 'store';
import LayoutMain from '../components/layout/LayoutMain';
import Dashboard from '../components/dashboard/Dashboard';
import CarriersRoutes from './carriersRoutes';
import ClaimsRoutes from './claimsRoutes';
import CompaniesRoutes from './companiesRoutes';
import JobsRoutes from './jobsRoutes';
import LeadsRoutes from './leadsRoutes';
import MoversRoutes from './moversRoutes';
import UsersRoutes from './usersRoutes';
import TrucksRoutes from './trucksRoutes';
import CustomersRoutes from './customersRoutes';
import TransactionsRoutes from './transactionsRoutes';
import SettingsRoutes from './settingsRoutes';
import ReportsRoutes from './reportsRoutes';
import ScheduleRoutes from './scheduleRoutes';
import RatesRoutes from './ratesRoutes';
import Settings from '../components/settings/Settings';
import Reports from '../components/reports/Reports';

import ClaimConfirm from '../components/claims/ClaimConfirm';
import Login from '../components/auth/Login';
import Register from '../components/auth/Register';
import VerifyEmail from '../components/auth/VerifyEmail';
import Update from '../components/auth/Update';
import VerifyPhone from '../components/auth/VerifyPhone';
import ForgotPassword from '../components/auth/ForgotPassword';
import ForgotPasswordEmailSent from '../components/auth/ForgotPasswordEmailSent';
import SetNewPassword from '../components/auth/SetNewPassword';
import SetNewPasswordSuccess from '../components/auth/SetNewPasswordSuccess';
import VerificationNotFound from '../components/auth/VerificationNotFound';
import VerificationExpired from '../components/auth/VerificationExpired';
import VerificationEmailResent from '../components/auth/VerificationEmailResent';
import ConfirmJob from '../components/movers/ConfirmJob';
import ContractsRoutes from './contractsRoutes';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      component: LayoutMain,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '/',
          name: 'Dashboard',
          component: Dashboard,
          meta: {
            title: 'Dashboard - Mod24',
          },
        },
        CarriersRoutes,
        CompaniesRoutes,
        JobsRoutes,
        LeadsRoutes,
        MoversRoutes,
        UsersRoutes,
        TrucksRoutes,
        CustomersRoutes,
        TransactionsRoutes,
        SettingsRoutes,
        RatesRoutes,
        ReportsRoutes,
        ScheduleRoutes,
        ClaimsRoutes,
        ContractsRoutes,
        {
          path: '/settings',
          name: 'Settings',
          component: Settings,
          meta: {
            title: 'Settings - Mod24',
          },
        },
        {
          path: '/reports',
          name: 'Reports',
          component: Reports,
          meta: {
            title: 'Reports - Mod24',
          },
        },
      ],
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: 'Login - Mod24',
      },
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      meta: {
        title: 'Register - Mod24',
      },
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword,
      meta: {
        title: 'Forgot Password - Mod24',
      },
    },
    {
      path: '/reset-password-email-sent',
      name: 'ForgotPasswordEmailSent',
      component: ForgotPasswordEmailSent,
      meta: {
        title: 'Email Sent - Mod24',
      },
    },
    {
      path: '/set-new-password/:token',
      name: 'SetNewPassword',
      component: SetNewPassword,
      meta: {
        title: 'Set New Password - Mod24',
      },
    },
    {
      path: '/set-new-password-success',
      name: 'SetNewPasswordSuccess',
      component: SetNewPasswordSuccess,
      meta: {
        title: 'Set New Password - Mod24',
      },
    },
    {
      path: '/verify',
      name: 'VerifyEmail',
      component: VerifyEmail,
      meta: {
        title: 'Verify Email - Mod24',
      },
    },
    {
      path: '/phone',
      name: 'VerifyPhone',
      meta: {
        title: 'Verify Phone - Mod24',
        requiresAuth: true,
      },
      component: VerifyPhone,
    },
    {
      path: '/update/:token',
      name: 'Update',
      component: Update,
      meta: {
        title: 'Update - Mod24',
      },
    },
    {
      path: '/verification-not-found',
      name: 'VerificationNotFound',
      component: VerificationNotFound,
      meta: {
        title: 'Verification Not Found - Mod24',
      },
    },
    {
      path: '/verification-expired',
      name: 'VerificationExpired',
      component: VerificationExpired,
      meta: {
        title: 'Verification Expired - Mod24',
      },
    },
    {
      path: '/verification-resent',
      name: 'VerificationEmailResent',
      component: VerificationEmailResent,
      meta: {
        title: 'Verification Email Resent - Mod24',
      },
    },
    {
      path: '/confirm-job/:token',
      name: 'ConfirmJob',
      component: ConfirmJob,
      meta: {
        title: 'Confirm Job - Mod24',
      },
    },
    {
      path: '/claims/confirm/:id',
      name: 'ClaimConfirm',
      component: ClaimConfirm,
      meta: {
        title: 'Confirm Claim - Mod24',
      },
    },
  ],
  mode: 'history',
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? to.meta.title : 'Mod24';
  const user = store.get('dispatchUser');
  if (user !== undefined && !user.phone_verified) {
    if (to.name !== 'VerifyPhone') {
      return next({ name: 'VerifyPhone' });
    }
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!user) {
      return next({ name: 'Login' });
    }
    if (user.phone_verified && user.company_setup_step === 1 && to.name !== 'CompaniesSetup') {
      return next({ name: 'CompaniesSetup' });
    }
    return next();
  }
  if (user && user.user_status_id === 1) {
    return next({ name: 'Dashboard' });
  }
  return next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js